import { useState, useEffect } from 'react';

import { SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { addContact, updateContact } from 'services/client-service';

import { ContactForm } from './forms/contact-form';
import { Content, UpdateMessageStyled, Title } from './contact.styled';

let _mounted = false;

export const Contact = (props) => {
  const { t } = useTranslation();
  const { clientId, refresh, contact } = props;
  const [updateMessage, setUpdateMessage] = useState(false);
  const isAdd = !contact;

  useEffect(() => {
    _mounted = true;

    return () => {
      _mounted = false;
    };
  }, []);

  /**
   * show update message
   */
  const showMessage = () => {
    setUpdateMessage(true);
    setTimeout(() => {
      if (_mounted) {
        setUpdateMessage(false);
      }
    }, 3000);
  };

  /**
   * save contact
   * @param {*} values
   * @returns
   */
  const save = (data) => {
    const rightUpdate = user.haveRight('clients.update');
    if (!rightUpdate) {
      return Promise.resolve();
    }

    const method = isAdd ? addContact : updateContact;

    return method(data, clientId)
      .then((data) => {
        showMessage();
        refresh(data);
      })
      .catch((error) => {
        // console.log('🚀 ~ save ~ errors:', errors);
        // let submissionErrors = {};
        // if (Array.isArray(errors)) {
        //   errors.forEach((element) => {
        //     submissionErrors[element.field] = element.type;
        //     submissionErrors._error = errors.type;
        //   });
        // }
        const out = { _error: error.toString() };

        console.log('🚀 ~ save ~ out:', out);
        throw new SubmissionError(out);
      });
  };

  return (
    <Content>
      <Title>{t('grid.Контактное лицо')}</Title>

      <ContactForm onSubmit={save} initialValues={contact} />

      {updateMessage && <UpdateMessageStyled>{t('grid.Изменения сохранены')}</UpdateMessageStyled>}
    </Content>
  );
};
